module.exports = __webpack_public_path__ + "img/no-data.bfe5b90f.png";